import { render, staticRenderFns } from "./IndicatorsList.vue?vue&type=template&id=36d313fc&scoped=true"
import script from "./IndicatorsList.vue?vue&type=script&lang=js"
export * from "./IndicatorsList.vue?vue&type=script&lang=js"
import style0 from "./IndicatorsList.vue?vue&type=style&index=0&id=36d313fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d313fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36d313fc')) {
      api.createRecord('36d313fc', component.options)
    } else {
      api.reload('36d313fc', component.options)
    }
    module.hot.accept("./IndicatorsList.vue?vue&type=template&id=36d313fc&scoped=true", function () {
      api.rerender('36d313fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/IndicatorsList.vue"
export default component.exports